// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbeddedBlok_root__dNydG"};